import PatFumbleForcedByPositionPref from "./pat-fumble-forced-by-position-pref";

export default class PatFumbleRecoveredByPositionPref extends PatFumbleForcedByPositionPref {
    constructor(play, fragment) {
        super(play, fragment);
    }
}
